<app-breadcrumb *ngIf="!pageObject"   [master]="'Narzędzia'" [parentName]="'Baza wiedzy'" [name]="'Dodaj strone'"></app-breadcrumb>
<div class="page-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button [class.spinner]="pageAdd" [disabled]="pageAdd"  (click)="sendForm()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz </span></button>
      <button [class.spinner]="pageAdd" [disabled]="pageAdd" (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="60" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3> Treść </h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">

          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Nazwa </mat-label>

              <input [required]="true"
                     [formControl]="nameControl"
                     appCapitalizeFirst matInput placeholder="Nazwa"  >
              <mat-error *ngIf="pageForm.get('name').hasError('required')">To pole jest wymagane</mat-error>


            </mat-form-field>
          </div>

        </div>


        <div fxLayout="column" fxFlex.lt-md="100" fxLayoutGap="15px" cdkDropList [cdkDropListData]="pageDetails" (cdkDropListDropped)="drop($event)">
          <ng-container *ngFor="let formGroup of pageDetails; let i = index">
            <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">
              <mat-card  *ngIf="formGroup.get('pageDetailType').value === 'TEXT'" fxFlex="100" fxLayoutGap="15px">
                <div   fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div cdkDrag  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Pole tekstowe</h3>

                      <button (click)="removePageDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div >
                  </div>
                  <div  fxLayout="row"  fxFlex="90">
                    <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="pageDetailText" [required]="true" ></angular-editor>
                  </div>
                </div >
              </mat-card>

              <mat-card cdkDrag *ngIf="formGroup.get('pageDetailType').value === 'GRAPHICS'" fxFlex="100" fxLayoutGap="15px">
                <div  fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div *ngIf="formGroup.get('pageDetailType').value === 'GRAPHICS'"  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Grafika</h3>

                      <button (click)="removePageDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div  fxLayout="row"  fxFlex="90">
                    <app-file-drag-and-drop fxFlex="100" [maxSize]="maxSize" [multiple]="false" [generateOutput]="true"
                                            acceptMime = "image/jpeg,image/png,image/gif,image/bmp,image/webp,image/svg+xml"
                                            (fileSelected)="onFileChange($event, i)"></app-file-drag-and-drop>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px" *ngIf="formGroup.get('pageDetailType').value === 'GRAPHICS'">
                    <div fxFlex="100">
                      <mat-form-field fxFlex="100">
                        <mat-label>Link </mat-label>
                        <input formControlName="pageDetailCtaLink" matInput placeholder="http://" [required]="false">
                      </mat-form-field>
                    </div>
                  </div>
                  <div *ngIf="formGroup.get('pageDetailType').value === 'GRAPHICS'  && !formGroup.get('edit').value && formGroup.get('pageDetailFileLocation').value" fxLayoutAlign="space-between center" fxFlex="100">
                    <img class=" avatar-360" src="/rest/crm/asf360/file/{{formGroup.get('pageDetailFileLocation').value}}/image/{{formGroup.get('pageDetailFilename').value}}" alt="Zdjęcie"/>
                  </div>
                </div>
              </mat-card>

              <mat-card cdkDrag *ngIf="formGroup.get('pageDetailType').value === 'CTA'" fxFlex="100" fxLayoutGap="15px">
                <div  fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. CTA</h3>

                      <button (click)="removePageDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div  fxLayout="row"  fxFlex="100">
                    <div  fxLayout="column"   fxFlex="100" >
                      <div fxLayout="row" fxLayoutGap="15px">
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Nagłówek CTA</mat-label>
                            <input formControlName="pageDetailCtaHeadline" matInput placeholder="Nagłówek CTA">
                          </mat-form-field>
                        </div>
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Tekst CTA</mat-label>
                            <input formControlName="pageDetailCtaText" matInput placeholder="Tekst CTA">
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutGap="15px">
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Link CTA</mat-label>
                            <input formControlName="pageDetailCtaLink" matInput placeholder="http://" [required]="true">
                          </mat-form-field>
                        </div>
                        <div fxFlex="50">
                          <mat-form-field fxFlex="100">
                            <mat-label>Przycisk CTA</mat-label>
                            <input formControlName="pageDetailCtaButton" matInput placeholder="Przycisk CTA" [required]="true">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div >
              </mat-card>

              <mat-card  *ngIf="formGroup.get('pageDetailType').value === 'TABLE'" fxFlex="100" fxLayoutGap="15px">
                <div  fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div cdkDrag fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Tabela</h3>
                      <mat-form-field fxFlex="30">
                        <mat-label>Ilość Kolumn</mat-label>
                        <input
                          type="number"
                          formControlName="pageTableColumn"
                          matInput
                          [required]="true"
                          min="2"
                          max="3">
                      </mat-form-field>
                      <button (click)="removePageDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                  <div  fxLayout="row"  fxFlex="100">
                    <div  fxLayout="column"  fxFlex="{{formGroup.get('pageTableColumn').value === 3 ? 33: 50 }}">
                      <div  fxLayout="row"  fxFlex="90">
                        <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="pageDetailText" [required]="true" ></angular-editor>
                      </div>


                    </div>
                    <div  fxLayout="column"  fxFlex="{{formGroup.get('pageTableColumn').value === 3 ? 33: 50 }}">
                      <div  fxLayout="row"  fxFlex="90">
                        <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="pageDetailTextSecond" [required]="true" ></angular-editor>
                      </div>


                    </div>
                    <div *ngIf="formGroup.get('pageTableColumn').value === 3 "  fxLayout="column"  fxFlex="33">
                      <div  fxLayout="row"  fxFlex="90">
                        <angular-editor  fxFlex="100" [config]="editorConfig" formControlName="pageDetailTextThird" [required]="true"></angular-editor>
                      </div>


                    </div>

                  </div>
                </div >
              </mat-card>

              <mat-card  *ngIf="formGroup.get('pageDetailType').value === 'MOVIE'" fxFlex="100" fxLayoutGap="15px">
                <div   fxLayout="column"   fxFlex="100" >
                  <div  fxLayout="row"   fxFlex="100" >
                    <div cdkDrag  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                      <h3>{{ i + 1 }}. Film</h3>

                      <button (click)="removePageDetailsControl(i)" mat-icon-button color="warn">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div >
                  </div>
                  <div  fxLayout="row"  fxFlex="90">
                    <mat-form-field fxFlex="100">
                      <mat-label>Link </mat-label>
                      <input formControlName="pageDetailMovieLink" matInput placeholder="http://" [required]="true">
                    </mat-form-field>
                  </div>
                </div >
              </mat-card>

            </div>
            <br>
          </ng-container>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
          <div fxFlex="20">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPageDetails('TEXT')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Pole tekstowe</span>
            </button>
          </div>
          <div fxFlex="20">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPageDetails('GRAPHICS')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Grafika</span>
            </button>
          </div>

          <div fxFlex="20">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPageDetails('CTA')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>CTA</span>
            </button>
          </div>
          <div fxFlex="20">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPageDetails('TABLE')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Tabela</span>
            </button>
          </div>
          <div fxFlex="20">
            <button fxFlex="100" fxLayoutGap="15px" (click)="addPageDetails('MOVIE')" mat-stroked-button color="accent">
              <mat-icon>add</mat-icon> <span>Film</span>
            </button>
          </div>
        </div>
      </mat-card>



    </div>

    <div fxLayout="column" fxFlex="40"  fxLayoutGap="15px">

      <mat-card  fxLayout="column" >
        <div fxLayout="row">
          <h3>
            Kontakt
          </h3>
        </div>

<!--        <div fxLayout="row">-->
<!--          <h4>Nagłówek: {{ header }}</h4>-->

<!--        </div>-->

        <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of userFormArray; index as i">
          <div fxLayout="row" fxLayoutGap="15px"  fxFlex="100" [formGroup]="formGroup">
            <div fxFlex="5"  fxLayoutGap="15px">
              <div class="list-remove-button">
                {{i+1}}.
              </div>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Imie i nazwisko</mat-label>
                <input appCapitalizeFirst matInput placeholder="Imie i nazwisko" formControlName="usersName" [required]="true">
                <mat-error *ngIf="formGroup.get('usersName').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Stanowisko</mat-label>
                <input appCapitalizeFirst matInput placeholder="Stanowisko" formControlName="usersPosition" [required]="false">
                <mat-error *ngIf="formGroup.get('usersPosition').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px"  fxFlex="100"   [formGroup]="formGroup">
            <div fxFlex="5"  fxLayoutGap="15px">
              <div class="list-remove-button">
                <button (click)="removeUsers(i)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Numer telefonu</mat-label>
                <input appCapitalizeFirst matInput placeholder="Numer telefonu" formControlName="usersPhone" [required]="true">
                <mat-error *ngIf="formGroup.get('usersPhone').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="47" >
              <mat-form-field class="tags-add-input" fxFlex="100">
                <mat-label>Email</mat-label>
                <input appCapitalizeFirst matInput placeholder="Email" formControlName="usersEmail" [required]="true">
                <mat-error *ngIf="formGroup.get('usersEmail').hasError('backendError')">{{errors.name}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
              </span>
          <button (click)="addUsers(true)" mat-stroked-button color="primary">
            <mat-icon>add_box</mat-icon> <span> Dodaj</span>
          </button>
        </div>
      </mat-card>


<!--      <mat-card>-->
<!--        <div fxLayout="row">-->
<!--          <h3>Uprawnienia</h3>-->
<!--        </div>-->

<!--        <div fxLayout="row" fxLayoutGap="15px">-->
<!--          <div  fxFlex="50">-->
<!--            <mat-slide-toggle [formControl]="permissionPartnerControl" >Partner</mat-slide-toggle>-->
<!--          </div>-->
<!--          <div  fxFlex="50">-->
<!--            <mat-slide-toggle  [formControl]="permissionOfwcaControl" >OFWCA</mat-slide-toggle>-->
<!--          </div>-->
<!--        </div>-->




<!--        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center" >-->
<!--          <div  fxFlex="100">-->
<!--            <app-dict  [label]="'Tagi Partnera'"-->
<!--                       [dictType]="'partner_tags'"-->
<!--                       [required]="false"-->
<!--                       [multiple]="true"-->
<!--                       [formControl]="permissionTagPartnerControl"></app-dict>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" >-->
<!--          <div  fxFlex="100" >-->
<!--            <app-dict-insurance-companies [formControl]="permissionRegistrationListControl"  [multiple]="true"  fxFlex="100" label="Rejestracje"></app-dict-insurance-companies>-->
<!--          </div>-->
<!--        </div>-->

<!--      </mat-card>-->
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button [class.spinner]="pageAdd" [disabled]="pageAdd"  (click)="sendForm()" mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button [class.spinner]="pageAdd" [disabled]="pageAdd" (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
